import css from "../styles/terms.css";

// closest() polyfill
if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i,
      el = this;
    do {
      i = matches.length;
      while (--i >= 0 && matches.item(i) !== el) {}
    } while (i < 0 && (el = el.parentElement));
    return el;
  };
}

//	Transforms input names into readable text
String.prototype.readify = function readify() {
  var r = /_/gi;
  var n = this.replace(r, " ");
  var n = n.charAt(0).toUpperCase() + n.slice(1);
  return n;
};

function presentLanguageSearch() {
  document.getElementById("language-queries").style.display = "block";
  document.getElementById("Search").focus();
}

function closeLanguageSearch() {
  const languageQueries = document.getElementById("language-queries")
  languageQueries && (languageQueries.style.display = "none");
}

async function getLanguages() {
  const response = await fetch("https://backup.faithcomesbyhearing.com/resources/gosplefilms.json");
  const dataList = await response.json();
  return dataList.map(({data})=> data)
}

function setDeleteHandler() {
  const deletes = [...document.getElementsByClassName("delete")];
  deletes.forEach(deletableElement=>{
    deletableElement.addEventListener('click', (e)=>{
      const qs = [...document.querySelectorAll(".query")];
      const parent = deletableElement.parentElement.parentElement;
      const child = deletableElement.parentElement;
      const match = qs.find(node=> node.dataset.sn == child.dataset.sn);
        if (match) {
            match.classList.remove("disabled");
            match.disabled = "false";
        }
        parent.removeChild(child);
    })
  })
}

function send(data) {
  return FCBH.axiosInstance.post(
      "https://backup.faithcomesbyhearing.com/ci/index.php/Gospel_films/requestv1",
      data
    );
}

// ------------------------------------------------------------------------------

//**
//** Events
//**
document.addEventListener("click", (e) => {
  const path = e.path;
  const languagesContainer = document.getElementById("language-queries");
  if (!path?.includes(searchbar) && !path?.includes(languagesContainer)) {
    closeLanguageSearch();
  }
});

const searchbar = document.getElementById("Search");

searchbar.onclick = function () {
  presentLanguageSearch();
};

document.getElementById("Search").onkeyup = function () {
  var value = this.value.trim();
  var results = document.getElementById("language-queries");
  const selectedLanguages = document.querySelectorAll(".selected-language");
  const ids = [...selectedLanguages].map((language) => language.dataset.sn);

  results.innerHTML = "";

  if (value) {
    var queries = window.fuse.search(value);
    for (var i = 0; i < queries.length; i++) {
      if (i > 4) {
        continue;
      }
      var q = queries[i].item;

      results.innerHTML +=
        `<p class='query dropdown-link w-dropdown-link pointer' data-matbs='${q.MATBookStatus}'
        data-lukbs='${q.LUKBookStatus}' data-jbs='${q.JHNBookStatus}' data-matvl='${q.MATVimeoLink}' 
        data-jvl='${q.JHNVimeoLink}' data-l='${q.Language}' data-v='${q.Version}' data-sn='${q.StockNumber}' 
        data-mrkvl='${q.MRKVimeoLink}' data-lukvl='${q.LUKVimeoLink}' data-rc='${q.RegionContact}' 
        data-sv='${q.StreamingVideo}' data-mrkbs='${q.MRKBookStatus}' data-rs='${q.RecordingStatus}' 
        style='margin:0;padding:10px 15px;border-bottom:1px solid #e6e6e6;cursor:pointer'> ${q.Language} - ${q.Version}</p>`
    }

    var qs = document.querySelectorAll(".query");

    for (var j = 0; j < qs.length; j++) {
      if (ids.includes(qs[j].dataset.sn)) {
        qs[j].disabled = true;
        qs[j].classList.add("disabled");
      }

      qs[j].onclick = function (l) {
        document.getElementById("error").classList.remove("error-message")
        document.getElementById("error").innerHTML = ""
        l.target.classList.add("disabled");
        if (l.target.disabled !== true)
          document.getElementById("gf-languages-selected").innerHTML +=
            `<p class='selected-language' data-l='${this.dataset.l}' data-v='${this.dataset.v}' data-sn='${this.dataset.sn}' 
            data-mrkvl='${this.dataset.mrkvl}' data-rc='${this.dataset.rc}' data-sv='${this.dataset.sv}' data-mrkbs='${this.dataset.mrkbs}' 
            data-matbs='${this.dataset.matbs}' data-lukbs='${this.dataset.lukbs}' data-jbs='${this.dataset.jbs}' data-matvl='${this.dataset.matvl}' 
            data-lukvl='${this.dataset.lukvl}' data-jvl='${this.dataset.jvl}' data-rs='${this.dataset.rs}'>
            <span style='color:#9e1e35;font-weight:bold'>&#10004;</span> ${this.dataset.l} - ${this.dataset.v} 
            <span class='hover delete' style='text-decoration:underline;font-size:14px;color:#9e1e35;margin-left:15px;cursor:pointer'>Delete</span></p>`;
        l.target.disabled = true;


        setDeleteHandler();
      };
    }
  }
};

const setErrorMessage = (message) => {
  const errorDiv = document.getElementById("error");
  errorDiv.classList.add("error-message");
  errorDiv.innerHTML = message;
}

document.querySelectorAll("input[type=submit]")[0].onclick = function (e) {
  e.preventDefault();

  var inputs = document.querySelectorAll("input, textarea");
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].style.border = "1px solid #ccc";
    document.getElementById("error").innerHTML = "";
  }

  var required = document.getElementById('wf-form-gospel-films-terms').querySelectorAll("[required]");
  for (var i = 0; i < required.length; i++) {
    if (!required[i].value.trim()) {
      required[i].style.border = "1px solid red";
      setErrorMessage(required[i].name.readify() + " is required.")
      return;
    }
  }

  if (!document.getElementById("Agree-Terms").checked) {
    document.getElementById("error").innerHTML =
      "Please agree to the above terms.";
    return;
  }

  if (document.getElementById("gf-languages-selected").innerHTML == "") {
    setErrorMessage("Please select a language.")
    return;
  }

  const fd = new FormData(document.getElementById('wf-form-gospel-films-terms'));

  const sls = document.getElementsByClassName("selected-language");
  
  for (let i = 0; i < sls.length; i++) {
    const sl = sls[i];
    fd.append("language[]", sl.dataset.l);
    fd.append("region_contact[]", sl.dataset.rc);
    fd.append("version[]", sl.dataset.v);
    fd.append("mat_vimeo_link[]", sl.dataset.matvl);
    fd.append("mrk_vimeo_link[]", sl.dataset.mrkvl);
    fd.append("john_vimeo_link[]", sl.dataset.jvl);
    fd.append("luke_vimeo_link[]", sl.dataset.lukvl);
    fd.append("stock_number[]", sl.dataset.sn);
    fd.append("mat_book_status[]", sl.dataset.matbs);
    fd.append("mrk_book_status[]", sl.dataset.mrkbs);
    fd.append("luke_book_status[]", sl.dataset.lukbs);
    fd.append("john_book_status[]", sl.dataset.jbs);
    fd.append("recording_status[]", sl.dataset.rs);
  }

  document.querySelectorAll("input[type=submit]")[0].value = "Processing...";

  send(fd)
    .then(function (response) {
      if (response.data === 'success') {
        document.getElementById("wf-form-gospel-films-terms").classList.add("success")
        document.getElementById("wf-form-gospel-films-terms").innerHTML =
          "<p class=txt-default-gray-dark>Thank you! Your request has been submitted. You will be hearing from our team once your request has been processed.</p>";
        window.scrollTo(0, 0);
      } else {
        setErrorMessage("Something went wrong. Please try again later.")
        document.querySelectorAll("input[type=submit]")[0].value = "Submit";
      }
    })
    .catch(function (e) {
      setErrorMessage("Something went wrong. Please try again later.")
      document.querySelectorAll("input[type=submit]")[0].value = "Submit";
    });
};

//**
//** Init
//**
var fuse;

getLanguages()
  .then(function (data) {
    //	drop into fuse
    window.fuse = new Fuse(data, {
      shouldSort: true,
      includeScore: true,
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 2,
      keys: ["Language", "Version"],
    });
  })
  .catch(function (e) {
    console.log(e);
  })
  .finally(function () {});
